import React from 'react';
import Box from "@mui/material/Box";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ArrowBackIos } from "@mui/icons-material";
import { getTableStyles } from "../../../../styles/InLineStyles/BoardStyles.js";

const GroupHeader = ({ groupName, isExpanded, onClick, isMobile }) => (
  <Box
    display="flex"
    alignItems="center"
    onClick={onClick}
    sx={{ cursor: "pointer" }}
  >
    <h3 style={{
      color: getTableStyles(groupName).color,
      marginRight: "2px",
      fontWeight: "600",
      fontSize: "18px"
    }}>
      {groupName}
    </h3>
    {isExpanded ? (
      <ArrowBackIos
        style={{
          transform: "rotate(270deg)",
          cursor: "pointer",
          color: getTableStyles(groupName).color,
          width: "18px",
          marginBottom: "6px",
        }}
      />
    ) : (
      <ArrowForwardIosIcon
        style={{
          marginTop: "3px",
          width: "18px",
          cursor: "pointer",
          color: getTableStyles(groupName).color,
        }}
      />
    )}
  </Box>
);

export default GroupHeader;
